export interface Branding {
  id: string;
  titulo: string;
  subtitulo: string;
  orgao_nome: string;
  logo_url: string | null;
}

export const DEFAULT_BRANDING: Branding = {
  id: "",
  titulo: "ProcessoFlow",
  subtitulo: "Gestão de Processos",
  orgao_nome: "",
  logo_url: null,
};

export interface BrandingUpdateInput {
  titulo: string;
  subtitulo: string;
  orgao_nome: string;
  logo_url: string | null;
}
